module.exports = __webpack_public_path__ + "static/media/fp-cl-logo.749b5312.jpg";